module.exports = __webpack_public_path__ + "media/images/icons/lightbulb-38d41517fd5b5cb7e942eb07f3ea2786.svg";